import { Component, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase, LocationInfo, ContextInfo } from 't4core';


@Component({
    selector: 't4-context-trace',
    templateUrl: './contextTrace.html',
  styleUrls: ['./contextTrace.css'],
})
export class T4ContextTrace extends ComponentBase {

  @Input() public context: string;

  private data: string = "";

  public async trace() {
    if (!this.data) {
      var result = await this.Api.get<ContextInfo>("/Util/Trace", { context: this.context });
      this.data = result.Name;
    }

    alert(this.data);
  }
}
